/**
 * The strategy label of an erasure, one string for both halves (decision row
 * 205, TA-586). The live half (`deleteSubjectRows`, packages/db) records it on
 * the `subject.deleted` event; the corpus half (`deleteSubject`, packages/
 * pipeline) records it on its receipt. They used to say two different things,
 * and the pipeline's said `crypto_shred`, a design (F-26, counsel question C3)
 * that no code runs.
 *
 * What the label states: the subject's rows were deleted, the append-only
 * event log was kept as written, and no key was destroyed.
 */
export const ERASURE_STRATEGY_ROWS_DELETED_EVENTS_RETAINED = "rows_deleted_events_retained" as const;
